module.exports = __webpack_public_path__ + "img/sqrt-swap.f97d0aa5.svg";